<h4>Reusable CSS widgets for your applications.</h4>

<div class="p-grid">
    <div class="col-12">
        <div class="card">
            <h4>Summary Boxes</h4>
            <div class="p-grid">
                <div class="col-12 p-md-3 widget-summary-box summary-box-messages">
                    <div class="card">
                        <div class="summary-box-title">Messages</div>
                        <p>152</p>
                        <img src="assets/layout/images/dashboard/icon-messages.svg" alt="sapphire" class="summary-box-icon">
                        <img src="assets/layout/images/dashboard/graph-messages.svg" alt="sapphire" class="summary-box-graph">
                    </div>
                </div>

                <div class="col-12 p-md-3 widget-summary-box summary-box-checkins">
                    <div class="card">
                        <div class="summary-box-title">Checkins</div>
                        <p>532</p>
                        <img src="assets/layout/images/dashboard/icon-checkins.svg" alt="sapphire" class="summary-box-icon">
                        <img src="assets/layout/images/dashboard/graph-checkins.svg" alt="sapphire" class="summary-box-graph">
                    </div>
                </div>

                <div class="col-12 p-md-3 widget-summary-box summary-box-filessynced">
                    <div class="card">
                        <div class="summary-box-title">Files Synced</div>
                        <p>28</p>
                        <img src="assets/layout/images/dashboard/icon-filessynced.svg" alt="sapphire" class="summary-box-icon">
                        <img src="assets/layout/images/dashboard/graph-filessynced.svg" alt="sapphire" class="summary-box-graph">
                    </div>
                </div>

                <div class="col-12 p-md-3 widget-summary-box summary-box-usersonline">
                    <div class="card">
                        <div class="summary-box-title">Users Online</div>
                        <p>256</p>
                        <img src="assets/layout/images/dashboard/icon-usersonline.svg" alt="sapphire" class="summary-box-icon">
                        <img src="assets/layout/images/dashboard/graph-usersonline.svg" alt="sapphire" class="summary-box-graph">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12">
        <div class="card">
            <h4>Overview Boxes</h4>
            <div class="p-grid">
                <div class="col-12 p-sm-6 p-xl-4 widget-overview-box monthly-sales">
                    <div class="card">
                        <div class="card-title">Monthly Sales</div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aliquam sed purus non porta. </p>
                        <img src="assets/layout/images/dashboard/asset-stats.svg" alt="sapphire">
                    </div>
                </div>

                <div class="col-12 p-sm-6 p-xl-4 widget-overview-box total-views">
                    <div class="card">
                        <div class="card-title">Total Views</div>
                        <div class="overview-numbers">26520 / day</div>
                        <img src="assets/layout/images/dashboard/asset-graph.svg" alt="sapphire">
                    </div>
                </div>

                <div class="col-12 p-xl-4 widget-overview-box connections">
                    <div class="card">
                        <div class="card-title">Connections</div>
                        <div class="overview-numbers">2,449,570</div>
                        <div class="p-grid">
                            <div class="col-4 connection-chart">
                                <img src="assets/layout/images/dashboard/asset-connectiongraph.svg" alt="sapphire">
                            </div>
                            <div class="col-8 connection-chart-legend">
                                <div class="p-grid">
                                    <div class="col-6"><span class="dot dot-green"></span>Online</div>
                                    <div class="col-6"><span>644,421</span> <i class="legend-arrow pi pi-caret-up"></i></div>

                                    <div class="col-6"><span class="dot dot-red"></span>Offline</div>
                                    <div class="col-6">537,777 <i class="legend-arrow pi pi-caret-up"></i></div>

                                    <div class="col-6"><span class="dot dot-orange"></span>Pending</div>
                                    <div class="col-6">570,099 <i class="legend-arrow pi pi-caret-up"></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 p-lg-6">
        <div class="widget-team card">
            <div class="card-title">Team Members</div>
            <ul>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-center">
                            <img src="assets/layout/images/dashboard/avatar-1.jpg" alt="sapphire">
                        </div>
                        <div class="p-col">
                            <div class="member-content">
                                <div class="member-name">Anne-Marije Marking</div>
                                <div clasS="member-status">
                                    <div class="dot dot-red"></div>
                                    <span>In a meeting</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-center">
                            <img src="assets/layout/images/dashboard/avatar-2.jpg" alt="sapphire">
                        </div>
                        <div class="p-col">
                            <div class="member-content">
                                <div class="member-name">Gabriel Soares</div>
                                <div clasS="member-status">
                                    <div class="dot dot-green"></div>
                                    <span>Online</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-center">
                            <img src="assets/layout/images/dashboard/avatar-3.jpg" alt="sapphire">
                        </div>
                        <div class="p-col">
                            <div class="member-content">
                                <div class="member-name">Hector Mariano</div>
                                <div clasS="member-status">
                                    <div class="dot dot-green"></div>
                                    <span>Online</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-center">
                            <img src="assets/layout/images/dashboard/avatar-4.jpg" alt="sapphire">
                        </div>
                        <div class="p-col">
                            <div class="member-content">
                                <div class="member-name">Paulina Gayoso</div>
                                <div clasS="member-status">
                                    <div class="dot dot-orange"></div>
                                    <span>Commuting</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="col-12">
            <div class="widget-location card">
                <img src="assets/layout/images/dashboard/puebla.jpg" alt="sapphire">
                <div class="location-content">
                    <div class="p-grid">
                        <div class="col-fixed col-align-top">
                            <div class="icon-container">
                                <i class="pi pi-map-marker"></i>
                            </div>
                        </div>
                        <div class="p-col">
                            <div class="location-name">Puebla</div>
                            <div class="location-subtitle">Where the magic happens</div>
                        </div>
                    </div>

                    <p>Earum porro tenetur consequuntur veritatis eos vel natus quisquam.</p>
                    <a href="#">READ MORE</a>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 p-lg-6">
        <div class="widget-timeline card">
            <div class="card-title">Recent Activities</div>
            <ul>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-top">
                            <div class="icon-container">
                                <i class="pi pi-map-marker"></i>
                            </div>
                        </div>
                        <div class="p-col">
                            <div class="event-owner">Katherine May</div>
                            <div class="event-detail">Lorem ipsun dolor amet</div>
                            <div class="grid p-nogutter">
                                <div class="col-4">
                                    <img src="assets/layout/images/dashboard/timeline-1.jpg" alt="sapphire">
                                </div>
                                <div class="col-4">
                                    <img src="assets/layout/images/dashboard/timeline-2.jpg" alt="sapphire">
                                </div>
                                <div class="col-4">
                                    <img src="assets/layout/images/dashboard/timeline-3.jpg" alt="sapphire">
                                </div>
                            </div>
                            <span class="timeline-clock"><i class="pi pi-clock"></i><span>12:30</span></span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-top">
                            <div class="icon-container">
                                <i class="pi pi-ticket"></i>
                            </div>
                        </div>
                        <div class="p-col">
                            <div class="event-owner">Brandon Williams</div>
                            <div class="event-detail">Ab nobis, magnam sunt eum. Laudantium, repudiandae, similique!.</div>
                            <span class="timeline-clock"><i class="pi pi-clock"></i><span>14:39</span></span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="grid p-nogutter">
                        <div class="col-fixed col-align-top">
                            <div class="icon-container">
                                <i class="pi pi-lock"></i>
                            </div>
                        </div>
                        <div class="p-col">
                            <div class="event-owner">Stephan Ward</div>
                            <div class="event-detail">Omnis veniam quibusdam ratione est repellat qui nam quisquam ab mollitia dolores ullam voluptates, similique, dignissimos.</div>
                            <img src="assets/layout/images/dashboard/timeline-4.jpg" alt="sapphire">
                            <span class="timeline-clock"><i class="pi pi-clock"></i><span>14:52</span></span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="grid p-nogutter location">
                        <div class="col-fixed col-align-top">
                            <div class="icon-container">
                                <i class="pi pi-image"></i>
                            </div>
                        </div>
                        <div class="p-col">
                            <div class="event-owner">Lara Cohen</div>
                            <div class="event-detail">Quibusdam ratione est repellat qui nam quisquam veniam quibusdam ratione..</div>
                            <span class="timeline-clock"><i class="pi pi-clock"></i><span>16:24</span></span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="col-12 p-lg-4">
        <div class="widget-userprofile card">
            <img src="assets/layout/images/dashboard/asset-profile.jpg" alt="sapphire" class="userprofile-bg">
            <img src="assets/layout/images/avatar.png" alt="sapphire" class="userprofile-avatar">
            <div class="userprofile-name">Helena Brauer</div>
            <div class="userprofile-role">Business Management</div>

            <div class="grid p-nogutter userprofile-legend">
                <div class="col-12 p-lg-4 userprofile-completed">
                    <div class="userprofile-circle"></div>
                    <div class="userprofile-status">COMPLETED</div>
                    <div class="userprofile-value">190</div>
                </div>
                <div class="col-12 p-lg-4 userprofile-snoozed">
                    <div class="userprofile-circle"></div>
                    <div class="userprofile-status">SNOOZED</div>
                    <div class="userprofile-value">64</div>
                </div>
                <div class="col-12 p-lg-4 userprofile-overdue">
                    <div class="userprofile-circle"></div>
                    <div class="userprofile-status">OVERDUE</div>
                    <div class="userprofile-value">28</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 p-lg-4">
        <div class="widget-weather card">
            <div class="weather-image">
                <div class="city-name">Prime City</div>
                <div class="weather-today">Snow</div>
                <div class="weather-degree">11 <span>&#8451;</span></div>
            </div>
            <div class="grid weekdays">
                <div class="col-6">Monday</div>
                <div class="col-6 weather-degree-col">-2 <span>&#8451;</span><img src="assets/layout/images/dashboard/asset-weathericon-2.svg" alt="sapphire"></div>
                <div class="col-6">Tuesday</div>
                <div class="col-6 weather-degree-col">--7 <span>&#8451;</span><img src="assets/layout/images/dashboard/asset-weathericon-3.svg" alt="sapphire"></div>
                <div class="col-6">Wednesday</div>
                <div class="col-6 weather-degree-col">2 <span>&#8451;</span><img src="assets/layout/images/dashboard/asset-weathericon-4.svg" alt="sapphire"></div>
                <div class="col-6">Thursday</div>
                <div class="col-6 weather-degree-col">4 <span>&#8451;</span><img src="assets/layout/images/dashboard/asset-weathericon-2.svg" alt="sapphire"></div>
                <div class="col-6">Friday</div>
                <div class="col-6 weather-degree-col">0 <span>&#8451;</span><img src="assets/layout/images/dashboard/asset-weathericon-3.svg" alt="sapphire"></div>
            </div>

        </div>
    </div>

    <div class="col-12 p-lg-4">
        <div class="widget-pricing-box">
            <div class="pricing-header">
                <h3>Pro</h3>
                <p class="pricing-fee"><b>$59</b>/mo</p>
            </div>

            <div class="pricing-content">
                <ul>
                    <li><i class="pi pi-check"></i> Responsive</li>
                    <li><i class="pi pi-check"></i> Push Messages</li>
                    <li><i class="pi pi-check"></i> 10 Support Tickets</li>
                    <li><i class="pi pi-check"></i> Free Shipping</li>
                    <li><i class="pi pi-times" style="color: #e53935"></i> Unlimited Space</li>
                </ul>
            </div>
        </div>
    </div>
</div>
